"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CreateProfile;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _awsAmplify = require("aws-amplify");
var _CreateProfileComponent = _interopRequireDefault(require("../components/CreateProfileComponent"));
var _reactRedux = require("react-redux");
var _roleReducer = require("../common_features/redux/reducers/roleReducer");
var _userDetailsReducer = require("../common_features/redux/reducers/userDetailsReducer");
var _Services = require("../common_features/utility/Services");
var _helper = require("../common_features/utility/helper");
var _loginReducer = require("../common_features/redux/reducers/loginReducer");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function CreateProfile(props) {
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const [country, setCountry] = (0, _react.useState)({});
  const [countryList, setCountryList] = (0, _react.useState)([]);
  const [countries, setCountries] = (0, _react.useState)('United States of America');
  const [firstName, setfirstName] = (0, _react.useState)(null);
  const [lastName, setlastName] = (0, _react.useState)(null);
  const [phoneNumber, setPhoneNumber] = (0, _react.useState)(null);
  const [zipcode, setZipcode] = (0, _react.useState)('');
  const [isZipCodeValid, setIsZipCodeValid] = (0, _react.useState)(false);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const [email, setEmail] = (0, _react.useState)(null);
  const [organization, setOrganization] = (0, _react.useState)(null);
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  const userType = userInfo.userType === 4 || userInfo.userType === 6;
  const getCurrentRole = user => {
    (0, _Services.getRoles)().then(async res => {
      if (res.success) {
        let resData = await (res === null || res === void 0 ? void 0 : res.data);
        dispatch((0, _loginReducer.SetUserRoles)(resData));
      }
    });
    let userType = user.signInUserSession.accessToken.payload["cognito:groups"][0];
    let roleId = (0, _helper.getUserTypeFromGroup)(userType);
    dispatch((0, _loginReducer.loginUserInfo)({
      challengeName: user.challengeName,
      poolId: user.pool.userPoolId,
      username: user.username,
      userType: roleId
    }));
  };
  const getCountryData = async () => {
    setIsLoading(true);
    (0, _Services.getCountryList)().then(res => {
      if (res.success) {
        const countries = res.data ? res.data.map(country => {
          return {
            code: country.code,
            title: country.name,
            key: country.name + country.code
          };
        }) : [];
        setCountryList(countries);
      }
    });
    setIsLoading(false);
  };
  const getRolesData = async () => {
    var _roles$data;
    const roles = await (0, _Services.getRoles)();
    let roleId = roles === null || roles === void 0 ? void 0 : (_roles$data = roles.data) === null || _roles$data === void 0 ? void 0 : _roles$data[0].roleId;
    dispatch((0, _roleReducer.roleInfo)(roles.data));
    return roleId;
  };
  const onChangeFirstNameHandler = async function (e) {
    setfirstName(e.target.value);
  };
  const onChangeLastNameHandler = async function (e) {
    setlastName(e.target.value);
  };
  const getUserData = async () => {
    setIsLoading(true);
    try {
      var _userDetailsData$data, _userDetailsData$data2, _userDetailsData$data3, _userDetailsData$data4, _userDetailsData$data5;
      let roleId = await getRolesData();
      let users = await _awsAmplify.Auth.currentAuthenticatedUser();
      let userPoolId = users.pool.userPoolId;
      let authUsername = users.username;
      let userID = "".concat(userPoolId, "#").concat(authUsername);
      let getUserId = userID;
      const userDetailsData = await (0, _Services.getUsers)(roleId, getUserId);
      let firstName = userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data = userDetailsData.data) === null || _userDetailsData$data === void 0 ? void 0 : _userDetailsData$data.firstName;
      setfirstName(firstName);
      let lastName = userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data2 = userDetailsData.data) === null || _userDetailsData$data2 === void 0 ? void 0 : _userDetailsData$data2.lastName;
      setlastName(lastName);
      let userEmail = userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data3 = userDetailsData.data) === null || _userDetailsData$data3 === void 0 ? void 0 : _userDetailsData$data3.email;
      setEmail(userEmail);
      let userOrganization = userType ? userDetailsData === null || userDetailsData === void 0 ? void 0 : userDetailsData.data.Organization.name : userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data4 = userDetailsData.data) === null || _userDetailsData$data4 === void 0 ? void 0 : (_userDetailsData$data5 = _userDetailsData$data4.ServiceProvider) === null || _userDetailsData$data5 === void 0 ? void 0 : _userDetailsData$data5.name;
      setOrganization(userOrganization);
      setIsLoading(false);
      dispatch((0, _userDetailsReducer.userDetailsInfo)(userDetailsData.data));
    } catch (error) {
      setIsLoading(false);
    }
  };
  const onZipcodeBlur = e => {
    setIsLoading(true);
    (0, _Services.GetCityState)({
      zipcode: e.target.value,
      country: 'US'
    }).then(data => {
      if (data.error) {
        setIsLoading(false);
        setIsZipCodeValid(true);
      } else {
        setIsLoading(false);
        setIsZipCodeValid(false);
      }
    });
  };
  const onChangeHandler = async function (e, name) {
    if (!e.target.onblur) {
      e.target.onblur = onZipcodeBlur;
    }
  };
  const updateUserProfile = async () => {
    setIsLoading(true);
    let countryName = countryList === null || countryList === void 0 ? void 0 : countryList[0].title;
    let countryZipcode = zipcode;
    let address = {
      "country": countryName,
      "zipcode": countryZipcode
    };
    let phone = phoneNumber;
    await (0, _Services.updateProfile)(firstName, lastName, JSON.stringify(address), phone).then(apiResp => {
      if (apiResp && apiResp.success) {
        navigate(_RoutePath.default.NotificationPreferencesOnboard.useLink);
      } else {
        alert("Something went wrong, please try again.");
      }
      setIsLoading(false);
    }).catch(error => {
      alert(error);
      setIsLoading(false);
    });
  };
  (0, _react.useEffect)(() => {
    _awsAmplify.Auth.currentAuthenticatedUser().then(user => {
      getCurrentRole(user);
      getCountryData();
      getUserData();
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_CreateProfileComponent.default, {
    isLoading: isLoading,
    headerText: "Welcome to ServiceConnect!",
    headerSubText: "Enter some information to get started!",
    phoneNumberText: "Mobile Phone Number",
    notificationsText: "This will be used for SMS notifications",
    zipCodeText: "Zip Code",
    countryText: "Country",
    firstNameText: "First Name",
    lastNameText: "Last Name",
    emailText: "Email",
    organizationText: "Organization",
    saveButton: "Save",
    firstName: firstName,
    onChangeFirstName: e => onChangeFirstNameHandler(e),
    lastName: lastName,
    onChangeLastName: e => onChangeLastNameHandler(e),
    countryDropDownList: countryList,
    countries: countries,
    setCountry: e => {
      setCountries(e.title);
      setCountry(e);
    },
    zipCode: zipcode,
    setZipCode: e => {
      setZipcode(e.target.value);
      onChangeHandler(e, 'zipcode');
    },
    isZipCodeValid: isZipCodeValid,
    phoneNumber: phoneNumber,
    onChangePhoneNumber: e => {
      setPhoneNumber(e);
    },
    email: email,
    onChangeEmail: email => {
      setEmail(email);
    },
    emailPlaceholder: "Enter Email",
    organization: organization,
    onChangeOrganization: organization => {
      setOrganization(organization);
    },
    organizationPlaceholder: "Enter Organization",
    onClickSave: updateUserProfile,
    onClickSaveDisabled: !((firstName === null || firstName === void 0 ? void 0 : firstName.length) > 0 && (lastName === null || lastName === void 0 ? void 0 : lastName.length) > 0 && countries && (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length) === 5),
    isValidPhoneNumber: (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.length) > 10 || (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.length) === undefined ? true : false,
    numberInvalidText: (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.length) > 10 || (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.length) === undefined ? "This will be used for SMS notifications" : "Please enter a valid phone number"
  }));
}